import { ChartSlide } from "./ChartSlide";

export default ChartSlide;
